const appSettings = {
    apiUrl: process.env.NODE_ENV === "production"
        ? "https://apiv2.telegramsexchat.com/telegram-s-chat"
        : "https://apiv2.telegramsexchat.com/telegram-s-chat"
        // : "http://localhost:3095/telegram-s-chat"
};

export default appSettings;
